import { threeInteractionStore } from '@modules/three/store/threeInteractionStore';

const useThreeInteractionStore = () => {
  const pointAdding = threeInteractionStore((state) => state.pointAdding);
  const setPointAdding = threeInteractionStore((state) => state.setPointAdding);

  const editableLineTool = threeInteractionStore((state) => state.editableLineTool);
  const setEditableLineTool = threeInteractionStore((state) => state.setEditableLineTool);

  const transformTool = threeInteractionStore((state) => state.transformTool);
  const setTransformTool = threeInteractionStore((state) => state.setTransformTool);

  const activeToolName = threeInteractionStore((state) => state.activeToolName);
  const setActiveTool = threeInteractionStore((state) => state.setActiveTool);

  const sculptMode = threeInteractionStore((state) => state.sculptMode);
  const setSculptMode = threeInteractionStore((state) => state.setSculptMode);

  return {
    pointAdding,
    setPointAdding,
    editableLineTool,
    setEditableLineTool,
    transformTool,
    setTransformTool,
    activeToolName,
    setActiveTool,
    sculptMode,
    setSculptMode,
  };
};
export default useThreeInteractionStore;
